var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"2.54032"}}),_c('circle',{attrs:{"cx":"12","cy":"19.4597","r":"2.54032"}}),_c('circle',{attrs:{"cx":"12","cy":"4.54032","r":"2.54032"}})])}
var staticRenderFns = []

export { render, staticRenderFns }